// Third Party Imports
import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';

// Relative Imports
import accountIcon from '../../images/account-icon';
import addressIcon from '../../images/address-icon';
import softwareIcon from '../../images/software-icon';
import businessIcon from '../../images/business-icon';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import AlertBox from '../Alert/Alert';
import SubHead from '../SubHead/SubHead';
import './Summary.less';
import {isUsSite} from '../../utils/validate';
import {MERCHANT_OF_RECORD} from '../../utils/constants';

export default class Summary extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    renderSummaryDetails(summaryDetail) {
        const {translations} = this.props;
        return summaryDetail.type === 'list' ?
            <ul>
                {
                    Object.keys(summaryDetail.contents).map((e, i) => {
                        return (<li className="summary-item" key={i}>
                            <span className="summary-item-label">{`${translations[e]}: `}</span>
                            <span className="summary-item-value">{summaryDetail.contents[e]}</span>
                        </li>);
                    })
                }
            </ul> :
            <div>
                {
                    summaryDetail.contents.map((e, i) => {
                        return (<div key={i} className="summary-item">{e}</div>);
                    })
                }
            </div>;
    }

    renderSummary(summaryDetails) {
        const {translations} = this.props;
        return Object.keys(summaryDetails).map((e, i) => {
            const isBusinessModel = e === 'ipmob.summary.business.model';
            const className = isBusinessModel ? 'summary-list-item business-model' : 'summary-list-item';

            return (<div key={i} className={className}>
                <div className="summary-list-heading">
                    <SVGIcon className="summary-list-icon" markup={summaryDetails[e].icon}/>
                    <h4 className="summary-list-heading-text">{translations[e]}</h4>
                </div>
                {(this.props.serviceError) ? null : this.renderSummaryDetails(summaryDetails[e])}
            </div>);
        });
    }

    render() {
        let {
            translations,
            firstName,
            lastName,
            emailAddress,
            companyName,
            softwareName,
            softwareUserId,
            propertiesManaged,
            address1,
            address2,
            city,
            state,
            country,
            postalCode,
            billingAddress1,
            billingAddress2,
            billingCity,
            billingState,
            billingCountry,
            billingPostalCode,
            serviceError,
            handleAlertDismiss,
            handleSaveAndFinishOnClick,
            isSaveModalOpen,
            handleSaveModalClose,
            hostName,
            siteName,
            sharedIpmBankingEnabled,
            advertiserBusinessModel
        } = this.props;

        const summaryDetails = {
            'ipmob.summary.account.information': {
                type: 'list',
                icon: accountIcon,
                contents: {
                    'ipmob.summary.account.information.name': `${firstName} ${lastName}`,
                    'ipmob.summary.account.information.email': emailAddress,
                    'ipmob.summary.account.information.company': companyName
                }
            },
            'ipmob.summary.software.details': {
                type: 'list',
                icon: softwareIcon,
                contents: {
                    'ipmob.summary.software.details.name': softwareName,
                    'ipmob.summary.software.details.userid': softwareUserId,
                    'ipmob.summary.software.details.properties.managed': propertiesManaged
                }
            },
            'ipmob.summary.mailing.address': {
                icon: addressIcon,
                contents: [
                    `${address1}`,
                    `${address2}`,
                    `${city}, ${state} ${postalCode}`,
                    `${country}`
                ]
            },
            'ipmob.billing_page.sub_heading_3': {
                icon: addressIcon,
                contents: [
                    `${billingAddress1}`,
                    `${billingAddress2}`,
                    `${billingCity}, ${billingState} ${billingPostalCode}`,
                    `${billingCountry}`
                ]
            }
        };

        // Only include business model section in summaryDetails if dyff flag is true
        if (sharedIpmBankingEnabled && advertiserBusinessModel) {
            // API returns all caps: "AGENCY" or "EXPEDIA"
            const isExpediaModel = advertiserBusinessModel === MERCHANT_OF_RECORD.EXPEDIA;

            const modelNameKey = isExpediaModel
                ? 'ipmob.summary.business_model.vrbo_mor'
                : 'ipmob.summary.business_model.agency_model';

            const modelDescriptionKey = isExpediaModel
                ? 'ipmob.summary.business_model.vrbo_mor_text_1'
                : 'ipmob.summary.business_model.agency_model_text_1';

            summaryDetails['ipmob.summary.business.model'] = {
                icon: businessIcon,
                contents: [
                    translations[modelNameKey],
                    translations[modelDescriptionKey]
                ]
            };
        }

        if (!isUsSite(siteName)) {
            summaryDetails['ipmob.summary.software.details'].contents['ipmob.summary.preferred.site'] = hostName;
        }

        return (
            <div id="summary" className="summary">
                <div className="summary-content-container">
                    <SubHead
                        translations={translations}
                        handleSaveAndFinishOnClick={handleSaveAndFinishOnClick}
                        isSaveModalOpen={isSaveModalOpen}
                        handleSaveModalClose={handleSaveModalClose}
                    />
                    {
                        serviceError
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <div className="wrapper">
                        <div className="summary-content-col">
                            <h2 className="summary-heading">{translations['ipmob.summary.heading']}</h2>
                            <div className="summary-desc">{translations['ipmob.summary.sub.heading']}</div>
                            {this.renderSummary(summaryDetails)}
                            <div className="summary-desc summery-footer">{translations['ipmob.summary.next.step']}</div>
                        </div>
                    </div>
                    <ContinueButtonHolder
                        handleContinueButtonClick={this.props.handleContinueButtonClick}
                        enableContinueButton
                        translations={translations}
                        continueButtonId={'summaryPageContnBtn'}
                    />
                </div>
            </div>
        );
    }
}
